module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/phone-wrap.60c69037.png";